import { AxiosRequestConfig } from 'axios';
import { Api } from 'src/api';
import { httpConfig } from 'src/lib/modules/http';

const baseUrl = `${httpConfig.options.baseURL}/media`;

export const restore = (model: string, config?: AxiosRequestConfig): Promise<void> =>
  Api.http.post(`${baseUrl}/${model}/restore`, {}, config);

/**
 * A URL that downloads the file as an attachment. Refused with a 409 (and a
 * message the global error toast shows) when the file never reached storage.
 */
export const downloadUrl = (
  model: string,
  config?: AxiosRequestConfig,
): Promise<{ download_url: string }> =>
  // The response interceptor unwraps JSON bodies, hence R = the body type.
  Api.http.get<{ download_url: string }, { download_url: string }>(
    `${baseUrl}/${model}/download-url`,
    config,
  );

export const restoreStatus = (model: string, config?: AxiosRequestConfig): Promise<void> =>
  Api.http.get(`${baseUrl}/${model}/restore-status`, config);
